import { forwardRef } from 'react';

import { IconProps } from './icons.types';

import { SvgStyled } from './icons.styles';

export const DocumentNoteIcon = forwardRef<SVGSVGElement, IconProps>(function DocumentNoteIcon(
  { color = '', height = 12, width = 12, ...props },
  ref,
) {
  return (
    <SvgStyled
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 13 12"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.33325 3.5C3.33325 3.26052 3.55711 3.06639 3.83325 3.06639H5.33325C5.60939 3.06639 5.83325 3.26052 5.83325 3.5C5.83325 3.73948 5.60939 3.93361 5.33325 3.93361H3.83325C3.55711 3.93361 3.33325 3.73948 3.33325 3.5Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.33325 6C3.33325 5.76052 3.55711 5.56639 3.83325 5.56639H8.83325C9.10939 5.56639 9.33325 5.76052 9.33325 6C9.33325 6.23948 9.10939 6.43361 8.83325 6.43361H3.83325C3.55711 6.43361 3.33325 6.23948 3.33325 6Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.3134 7.06586C12.3271 6.7324 12.3333 6.37753 12.3333 6C12.3333 1.059 11.2743 0 6.33325 0C1.39225 0 0.333252 1.059 0.333252 6C0.333252 10.941 1.39225 12 6.33325 12C6.68627 12 7.01947 11.9946 7.33389 11.9828C7.50591 11.9763 7.67231 11.9679 7.83325 11.9574C8.00534 11.9461 8.17119 11.9325 8.331 11.9163C11.0114 11.6442 11.9956 10.6404 12.256 7.93258C12.2694 7.79296 12.2809 7.64881 12.2906 7.5C12.2998 7.35948 12.3074 7.21481 12.3134 7.06586ZM11.3128 7.06544C11.3268 6.73595 11.3333 6.38153 11.3333 6C11.3333 4.78167 11.267 3.85445 11.1087 3.14214C10.9512 2.43353 10.7158 2.00048 10.4306 1.7153C9.8746 1.15926 8.82273 0.86722 6.33325 0.86722C3.84377 0.86722 2.7919 1.15926 2.23586 1.7153C1.95068 2.00048 1.71533 2.43353 1.55785 3.14214C1.39955 3.85445 1.33325 4.78167 1.33325 6C1.33325 7.21833 1.39955 8.14555 1.55785 8.85786C1.71533 9.56647 1.95068 9.99952 2.23586 10.2847C2.7919 10.8407 3.84377 11.1328 6.33325 11.1328C6.68804 11.1328 7.01746 11.1271 7.32368 11.1151C7.332 10.9705 7.34587 10.8133 7.36777 10.648C7.46563 9.90881 7.73201 8.93941 8.45551 8.21591C9.1891 7.48233 10.1866 7.20437 10.9552 7.10261C11.0795 7.08615 11.1993 7.07409 11.3128 7.06544ZM8.33027 11.0426C8.3376 10.9484 8.34768 10.8493 8.36124 10.7469C8.45088 10.0699 8.68449 9.31059 9.21099 8.78409C9.72741 8.26767 10.4586 8.04563 11.1061 7.95989C11.1553 7.95338 11.2037 7.9477 11.2511 7.94277C11.1209 9.19762 10.8355 9.87982 10.4306 10.2847C10.0639 10.6515 9.46999 10.9142 8.33027 11.0426Z"
        fill={color || 'currentColor'}
      />
    </SvgStyled>
  );
});
